import React, { Fragment, useEffect, useRef, useState } from "react";
import "./Search.css";
import { Col, Empty, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faMusic,
  faNotdef,
  faTableList,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import TrackOrTrackListItem from "../Personal/TrackOrTrackListItem/TrackOrTrackListItem";
import axios from "axios";
import {
  resetSearch,
  setSearchType,
  setSearchValue,
} from "../../Redux/SearchSlice";
import SearchAccountItem from "./SearchAccountItem/SearchAccountItem";

function Search() {
  const dispatch = useDispatch();
  const searchValueSelector = useSelector((state) => state.search.value);
  const searchTypeSelector = useSelector((state) => state.search.type);
  const [foundedResults, setFoundedResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const isInitialMount = useRef(true);

  // refresh dữ liệu redux khi rời khỏi component
  useEffect(() => {
    return () => {
      if (!isInitialMount.current) {
        dispatch(resetSearch());
      }
      isInitialMount.current = false;
    };
  }, []);

  // fetch search result
  useEffect(() => {
    getSearchResult();
  }, [searchValueSelector, searchTypeSelector]);

  const getSearchResult = async () => {
    setLoading(true);
    if (
      searchValueSelector === null ||
      searchValueSelector === undefined ||
      searchValueSelector === ""
    ) {
      setLoading(false);
      return;
    }
    try {
      let endpoints = [];

      if (searchTypeSelector === "all" || searchTypeSelector === "track") {
        endpoints.push(
          axios.get(`${process.env.REACT_APP_SERVER_URL}/track/get-by-search`, {
            params: { title: searchValueSelector, category: "track" },
          })
        );
      }
      if (searchTypeSelector === "all" || searchTypeSelector === "user") {
        endpoints.push(
          axios.get(`${process.env.REACT_APP_SERVER_URL}/user/get-by-search`, {
            params: { username: searchValueSelector },
          })
        );
      }

      const responses = await Promise.all(endpoints);
      const resArr = responses.flatMap((res) => res.data || []);

      setFoundedResults(resArr);
    } catch (err) {
      console.error("Error fetching search results:", err);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  return (
    <>
      <Col className="searchPageTitleWrapper" span={18} offset={3}>
        <span className="searchPageTitle">
          Các kết quả tìm kiếm cho "{searchValueSelector}"
        </span>
      </Col>
      <Col span={24} />
      <Col span={3} offset={3} className="searchOptionsWrapper">
        <OptionItem title={"Tất cả"} icon={faMagnifyingGlass} value={"all"} />
        <OptionItem title={"Track"} icon={faMusic} value={"track"} />
        <OptionItem title={"Người dùng"} icon={faUser} value={"user"} />
        <OptionItem title={"Album"} icon={faTableList} value={"album"} />
        <OptionItem title={"Playlist"} icon={faTableList} value={"playlist"} />
      </Col>
      <Col span={14} offset={1} className="searchResultWrapper">
        {loading ? (
          <Spin size="large" className="searchResultEmpty" />
        ) : foundedResults.length > 0 ? (
          <>
            {foundedResults.map((trackOrUserOrTracklist) => {
              return (
                <React.Fragment key={trackOrUserOrTracklist._id}>
                  <ShowTrackandTrackListandUserItem
                    trackOrUserOrTracklist={trackOrUserOrTracklist}
                  />
                </React.Fragment>
              );
            })}
          </>
        ) : (
          <Empty
            className="searchResultEmpty"
            image={
              <img
                alt="Empty"
                src="/empty-search-icon.png"
                className="searchResultEmptyImg"
              />
            }
            description={
              <span className="searchResultEmptyTitle">{`Không tìm thấy kết quả nào phù hợp cho "${
                searchValueSelector === null ? "" : searchValueSelector
              }"`}</span>
            }
          />
        )}
      </Col>
    </>
  );
}

function ShowTrackandTrackListandUserItem({ trackOrUserOrTracklist }) {
  if (trackOrUserOrTracklist?.username) {
    return <SearchAccountItem userInfo={trackOrUserOrTracklist} />;
  } else if (
    trackOrUserOrTracklist?.category &&
    trackOrUserOrTracklist?.category === "track"
  ) {
    return (
      <TrackOrTrackListItem
        trackType="track"
        key={trackOrUserOrTracklist._id}
        trackOrTracklist={trackOrUserOrTracklist}
      />
    );
  }
}

function OptionItem({ title, icon = faNotdef, value = "all" }) {
  const dispatch = useDispatch();
  const searchTypeSelector = useSelector((state) => state.search.type);
  const isFocus = value === searchTypeSelector;

  const handleChangeSearchType = () => {
    dispatch(setSearchType({ type: value }));
  };

  return (
    <button
      onClick={handleChangeSearchType}
      className={`searchOptionItemBtn ${isFocus && "isFocus"}`}
    >
      <FontAwesomeIcon icon={icon} />
      <span className="searchOptionTitle">{title}</span>
    </button>
  );
}

export default Search;
